import styled from "styled-components";

export const Item = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #dfdbdbff;
`;

export const Name = styled.span`
  font-size: 15px;
  color: #333;
`;

export const DeleteBtn = styled.button`
  background: #ed1515ff;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 4px 10px;
  font-family: "Iosevka Charon", monospace;
  font-size: 14px;
  color: #ffffffff;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: none;
    border: 1px solid #e70606ff;
    color: #000000ff;
  }
`;
